<template>
<div class="popup" v-cloak v-show="RemindBindEmailShow"  style="zIndex:200">
    <div class="content" id="deleteRemind">
        <div class="title">
            {{$t('language.rightTopBanner.bindEmail')}}
            <div class="icon white-close dialog-close" @click="closePage()"></div>
        </div>
        <div class="email-remind-content">    
            {{$t('language.paySystem.payFirst')}}<span v-html="$t('language.paySystem.paybindEmail')" @click="openBindEmail()"></span>{{$t('language.paySystem.payEnd')}}
            <div class="bind-remind-footer">
                <div class="bind-button" >
                    <button style="border-radius: 5Px;" @click="openBindEmail()">{{$t('language.common.ok')}}</button>
               
                </div>
              
                <div>

                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import commonstate from '@/js/constant.js';
import commonUtils from "@/js/workspace/common_util.js";
export default {
    data: function () {
        return {
            RemindBindEmailShow: false,
        }
    },
    methods: {
       closePage(){
         this.RemindBindEmailShow = false;
       },
       openBindEmail(){
           this.$parent.$parent.$refs.bindEmail.bindEmailShow=true;
           this.RemindBindEmailShow=false;
       }
 

    }
}
</script>

<style>
#deleteRemind {
    width: 510Px;
    height: 190Px;
}

.email-remind-content {
    width: 100%;
    height: 150Px;
    box-sizing: border-box;
    padding: 20px 15px;
    /*no*/
    font-size: 14px;
    /*no*/
    line-height: 20Px;
}

.bind-remind-footer {
    height: 35Px;
}

.bind-button {
    float: right;
    margin-top: 25Px;
}



</style>



// WEBPACK FOOTER //
// src/components/popup/pay_system_popups/bind_email_topay_popup.vue